import React, { FC } from 'react';

import { Table } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import { ErrorBoundary } from 'client/blocks/ErrorBoundary/ErrorBoundary';
import { Link } from 'client/blocks/Link/Link';
import { moment } from 'client/lib/moment';
import { routes } from 'client/lib/routes';
import { getOperationLabelsTranslated } from 'client/locale/ru/operations';
import { OperationEvent } from 'client/model/operation';
import * as keyset from 'i18n/SkillsIndex';

import styles from './OperationEvents.module.scss';

const t = i18n(keyset);

interface OperationEventsProps {
    events: OperationEvent<React.ReactNode>[];
}

export const OperationEventsWithName: FC<OperationEventsProps> = ({ events }) => {
    const columns = [
        { id: 'event', name: t('table-event'), className: styles.tableCellWithName__event },
        { id: 'name', name: t('title'), className: styles.tableCellWithName__name },
        { id: 'time', name: t('table-time'), className: styles.tableCellWithName__time },
    ];
    const data = events.map((event) => ({
        event: getOperationLabelsTranslated(event?.skillEntity?.channel)[event?.operation?.type],
        name: event.operation.itemId ? (
            <Link to={routes.app.skill(event.operation.itemId)}>{event.operation.itemName}</Link>
        ) : (
            event.operation.itemName
        ),
        time: moment(event.operation.createdAt).fromNow(),
    }));

    if (!events?.length) {
        return null;
    }

    return (
        <ErrorBoundary>
            <div>
                <h2 className={styles.title}>{t('events')}</h2>
                <Table className={styles.operationTable} columns={columns} data={data} />
            </div>
        </ErrorBoundary>
    );
};
